(function () {
    'use strict';

    var module = angular.module('uwAgenda.search');
    module.filter('SearchHighlightFilter', ['$sce', SearchHighlightFilterFn]);

    function SearchHighlightFilterFn($sce) {
        // highlight match
        return function (text, search) {
            if (text === null) { return; }
            var regex = new RegExp('(' + removeSpecialChars(search) + ')', 'i');
            return $sce.trustAsHtml(text.replace(regex, '<span class="bold">$&</span>'));
        };

        function removeSpecialChars(str) {
            return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "");
        }
    }
})();
